import React, {useCallback, useRef, useState} from 'react';
import '../../styles/HomeMembershipForm.css'; // New simple CSS
import '../../styles/Message.css';
import emailjs from '@emailjs/browser';
import {AiOutlineCheckCircle} from 'react-icons/ai';
import ProtectedFormGate from '../ProtectedFormGate';

function HomeMembershipForm() {

    // Modal message
    const [modal, setModal] = useState(false);
    const showModal = () => setModal(!modal);

    const form = useRef();

    // ADDED: local-date-safe helper (avoids toISOString's UTC shift causing off-by-one errors)
    const formatDateLocal = (date) => { // ADDED
        const year = date.getFullYear(); // ADDED
        const month = String(date.getMonth() + 1).padStart(2, '0'); // ADDED
        const day = String(date.getDate()).padStart(2, '0'); // ADDED
        return `${year}-${month}-${day}`; // ADDED
    }; // ADDED

    // ADDED: date bounds for validation (today up to 10 years from now)
    const todayStr = formatDateLocal(new Date()); // CHANGED: now uses formatDateLocal instead of toISOString
    const maxDateObj = new Date(); // ADDED
    maxDateObj.setFullYear(maxDateObj.getFullYear() + 10); // ADDED
    const maxDateStr = formatDateLocal(maxDateObj); // CHANGED: now uses formatDateLocal instead of toISOString

    const sendEmail = (e) => {
      e.preventDefault();

      // ADDED: hard guard — block sending if date is out of range, even if the live clamp was bypassed
      if (udate) { // ADDED
          const selected = new Date(udate + 'T00:00:00'); // ADDED
          const minAllowed = new Date(todayStr + 'T00:00:00'); // ADDED
          const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // ADDED
          if (selected < minAllowed || selected > maxAllowed) { // ADDED
              setUdate(todayStr); // ADDED: reset to a safe value
              return; // ADDED: stop submission
          } // ADDED
      } // ADDED

      // ADDED: hard guard — block sending if guests is invalid
      if (!uguests || Number(uguests) < 1) { // ADDED
          setUguests("1"); // ADDED
          return; // ADDED
      } // ADDED

      // ADDED: hard guard — block sending if name contains invalid characters
      if (!/^[A-Za-z\s'-]+$/.test(uname.trim())) { // ADDED
          return; // ADDED
      } // ADDED

      emailjs.sendForm('service_hajj6js', 'template_s15xwnf', form.current, '0rx8q5OoEx4JOdxmR')
        .then((result) => {
            e.target.reset();
            setUname("");
            setUemail("");
            setUcontact("");
            setUplan("");
            setUdate("");    // ADDED: reset new date field on success
            setUguests("");  // ADDED: reset new guests field on success
            showModal(); // Trigger success modal
        }, (error) => {
            console.log(error.text);
        });
    };

    const [uname, setUname] = useState("");
    const [uemail, setUemail] = useState("");
    const [ucontact, setUcontact] = useState("");
    const [uplan, setUplan] = useState("");
    const [udate, setUdate] = useState("");     // ADDED
    const [uguests, setUguests] = useState(""); // ADDED

    const fillAccountFields = useCallback(({ user, profile }) => {
        const metadata = user?.user_metadata || {};
        const profileName = profile?.full_name || metadata.full_name || metadata.name || "";
        const profileEmail = profile?.email || user?.email || "";
        const profilePhone = profile?.phone_number || metadata.phone || "";

        setUname((current) => current || profileName);
        setUemail((current) => current || profileEmail);
        setUcontact((current) => current || profilePhone);
    }, []);

    // ADDED: strips digits/symbols from the name as the user types (letters, spaces, hyphens, apostrophes only)
    const handleNameChange = (e) => { // ADDED
        const cleaned = e.target.value.replace(/[^A-Za-z\s'-]/g, ''); // ADDED
        setUname(cleaned); // ADDED
    }; // ADDED

    // CHANGED: now compares actual Date objects instead of raw strings for reliability
    const handleDateChange = (e) => {
        const value = e.target.value;
        if (!value) {
            setUdate(value);
            return;
        }
        const selected = new Date(value + 'T00:00:00'); // CHANGED
        const minAllowed = new Date(todayStr + 'T00:00:00'); // CHANGED
        const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // CHANGED
        if (selected < minAllowed) { // CHANGED
            setUdate(todayStr);
            return;
        }
        if (selected > maxAllowed) { // CHANGED
            setUdate(maxDateStr);
            return;
        }
        setUdate(value);
    };

    // ADDED: prevents negative, zero, or decimal guest counts
    const handleGuestsChange = (e) => {
        const value = e.target.value;
        if (value === "") {
            setUguests(value);
            return;
        }
        const num = Number(value);
        if (Number.isNaN(num) || num < 1) {
            setUguests("1");
            return;
        }
        setUguests(String(Math.floor(num)));
    };

    const validate = () => {
        // CHANGED: added date-range check via Date objects, guests check, and name-pattern check
        const nameValid = /^[A-Za-z\s'-]+$/.test(uname.trim()); // ADDED
        let dateValid = false; // ADDED
        if (udate) { // ADDED
            const selected = new Date(udate + 'T00:00:00'); // ADDED
            const minAllowed = new Date(todayStr + 'T00:00:00'); // ADDED
            const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // ADDED
            dateValid = selected >= minAllowed && selected <= maxAllowed; // ADDED
        } // ADDED

        return uname.length && nameValid && uemail.length && ucontact.length && uplan.length
            && udate.length && dateValid && uguests.length && Number(uguests) > 0; // CHANGED
    };

  return (
    <>
        {/* MODAL POP-UP */}
        <div className={modal ? 'modal-wrap active' : 'modal-wrap'}>
            <div className="modal-box">
                <AiOutlineCheckCircle className='checkIcon' />
                <h1>Thank You!</h1>
                <p>Your details have been successfully <br/> submitted. Thanks!</p>
                <div className="exit-btn">
                    <button onClick={showModal}>OK</button>
                </div>
            </div>
        </div>

        <section className="home-form-section">
            <div className="simple-form-card" data-aos="fade-up">
                <ProtectedFormGate
                    title="Sign in to submit a membership inquiry"
                    description="Create an account or log in so we can save your details and assist you faster with the right membership plan."
                    contextLabel="Members inquiry"
                    formRef={form}
                    onAuthenticated={fillAccountFields}
                >
                    {({ guardSubmit }) => (
                        <>
                            <div className="simple-form-header">
                                <h2>Membership Form</h2>
                                <p>Complete the details below to inquire about our plans.</p>
                            </div>

                            <form ref={form} onSubmit={(e) => guardSubmit(e, sendEmail)}>
                                <div className="input-field">
                                    <label htmlFor="user_name">Name</label>
                                    <input
                                        type="text"
                                        name="user_name"
                                        value={uname}
                                        onChange={handleNameChange}
                                        placeholder="Enter your full name"
                                        pattern="[A-Za-z\s'-]+"
                                        title="Name must not contain numbers or symbols"
                                    />
                                    {/* CHANGED: onChange now uses handleNameChange; added pattern + title for backstop validation */}
                                </div>

                                <div className='form-row'>
                                    <div className="input-field">
                                        <label htmlFor="user_email">Email Address</label>
                                        <input type="email" name="user_email" value={uemail} onChange={(e) => setUemail(e.target.value)} placeholder="example@gmail.com" />
                                    </div>
                                    <div className="input-field">
                                        <label htmlFor="user_contact">Contact Number</label>
                                        <input type="number" name="user_contact" value={ucontact} onChange={(e) => setUcontact(e.target.value)} placeholder="09XXXXXXXXX" />
                                    </div>
                                </div>

                                {/* ADDED: new field row for Preferred Date + Number of Guests */}
                                <div className='form-row'>
                                    <div className="input-field">
                                        <label htmlFor="user_date">Preferred Date</label>
                                        <input
                                            type="date"
                                            name="user_date"
                                            id="user_date"
                                            value={udate}
                                            onChange={handleDateChange}
                                            min={todayStr}
                                            max={maxDateStr}
                                            required
                                        />
                                    </div>
                                    <div className="input-field">
                                        <label htmlFor="user_guests">Number of Guests</label>
                                        <input
                                            type="number"
                                            name="user_guests"
                                            id="user_guests"
                                            value={uguests}
                                            onChange={handleGuestsChange}
                                            min="1"
                                            placeholder="1"
                                            required
                                        />
                                    </div>
                                </div>
                                {/* END ADDED */}

                                <div className="input-field">
                                    <label htmlFor="user_plan">Select Plan</label>
                                    <select name="user_plan" id="plan" value={uplan} onChange={(e) => setUplan(e.target.value)} required>
                                        <option value="" disabled>Choose a membership plan</option>
                                        <option value="Annual Premiere">Annual Premiere</option>
                                        <option value="Semi-Annual Premiere">Semi-Annual Premiere</option>
                                        <option value="Gym Access">Gym Access</option>
                                    </select>
                                </div>

                                <div className="form-footer">
                                    <button className='simple-submit-btn' type="submit" disabled={!validate()}>Submit Application</button>
                                </div>
                            </form>
                        </>
                    )}
                </ProtectedFormGate>
            </div>
        </section>
    </>
  )
}

export default HomeMembershipForm;

// OLD INQUIRY FORM / PAGE
// import React, {useRef, useState} from 'react';
// import '../../styles/Inquiry.css';
// import '../../styles/Message.css';
// import emailjs from '@emailjs/browser';
// import {AiOutlineCheckCircle} from 'react-icons/ai';

// function Index() {

//     //Modal message
//     const [modal, setModal] = useState(false);

//     const showModal = () => {
//         setModal(!modal);
//     }

//     const form = useRef();

//     const sendEmail = (e) => {
//       e.preventDefault();

//       emailjs.sendForm('service_hajj6js', 'template_s15xwnf', form.current, '0rx8q5OoEx4JOdxmR')
//         .then((result) => {
//             // console.log(result.text);
//             e.target.reset();
//             //reseting the value after submit
//             setUname("");
//             setUemail("");
//             setUcontact("");
//             // alert("success");
//         }, (error) => {
//             // console.log(error.text);
//         });
//     };

//     //form value
//     const [uname, setUname] = useState("");
//     const [uemail, setUemail] = useState("");
//     const [ucontact, setUcontact] = useState("");


//     //check if input form is filled
//     const validate = () => {
//         return uname.length && uemail.length && ucontact.length;
//     };

//     //disable the button if the form is invali and enable if valid or filled
//     //reset form

//   return (
//     <>
//     {/**MODAL POP-UP WHEN FORM IS SUBMITTED */}
//         <div className={modal ? 'modal-wrap active' : 'modal-wrap'}>
//             <div className="modal-box">
//                 <AiOutlineCheckCircle className='checkIcon' />
//                 <h1>Thank You!</h1>
//                 <p>Your details has been successfully <br/> submitted. Thanks!</p>

//                 <div className="exit-btn">
//                     <button onClick={showModal} >OK</button>
//                 </div>
//             </div>
//         </div>

//         {/* <div className="hero-wrap" data-aos="fade">
//             <div className="hero-img">
//                 <img src="/vscimages/inquiry/inquiryb.jpg" alt="" />
//             </div>
//         </div> */}
//         <div className="inquiry-wrap" data-aos="fade-up">
//             <div className="inquiry-form">
//                 <div className="form-grid">
//                     <div className="form-col">
//                         <div className="form-title">
                            

//                             <h1 className="hide">
//                                 GET FIT
//                                 GET HEALTHY
//                                 GET STRONG
//                             </h1>
//                         </div>
//                     </div>

//                     <div className="form-col">
//                         <form ref={form} onSubmit={sendEmail}>
//                             <label htmlFor="user_name">Name</label>
//                             <input type="text" name="user_name" value={uname} onChange={(e) => setUname(e.target.value)} />

//                             <div className='form-grid'>
//                                 <div>
//                                     <label htmlFor="user_email">Email Address</label>
//                                     <input type="email" name="user_email" value={uemail} onChange={(e) => setUemail(e.target.value)} />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="user_contact">Contact Number</label>
//                                     <input type="number" name="user_contact" id="contact" value={ucontact} onChange={(e) => setUcontact(e.target.value)}/>
//                                 </div>
//                             </div>

//                             <label htmlFor="user_plan">Select Plan</label>
//                             <select name="user_plan" id="plan" required>
//                                 <option value=""></option>
//                                 <option value="Annual Premiere">Annual Premiere</option>
//                                 <option value="Semi-Annual Premiere">Semi-Annual Premiere</option>
//                                 <option value="Gym Access">Gym Access</option>
//                                 {/**<option value="Gym Access + 1">Gym Access + 1</option> */}
//                             </select>

//                             <br/>

//                             <div className="submit-wrap">
//                                 <button className='submit-btn' type="submit" onClick={showModal} disabled={!validate()}>Submit</button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </>
//   )
// }

// export default Index